import env from "react-dotenv";
import { parseJSON } from "../../helpers/json";
import { API_ENDPOINT } from '../../constants';

export default {
    'sync-prices': {
        onLoad: false,
        action: (data) => {
            const { customerId } = data;
            return fetch(API_ENDPOINT + `/data/syncronization-prices/${customerId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                console.log(result, status, 11)
                return { result, status };
            })
        }
    },
    'save': {
        onLoad: false,
        action: (data) => {
            return fetch(API_ENDPOINT + '/data/syncronization-products-without-photos', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                return { result, status };
            })
        }
    },
    'generate-report': {
        onLoad: false,
        action: (data) => {
            return fetch(API_ENDPOINT + '/data/script/generate-xlsx-report', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                return { result, status };

            }, (error) => {
                return { error};
            })
        }
    },
}